import { z } from 'zod';

export const CLIENT_TABS = ['profile', 'contacts', 'projects', 'invoices'] as const;
export type ClientTab = (typeof CLIENT_TABS)[number];

export const isClientTab = (value: string): value is ClientTab =>
  (CLIENT_TABS as readonly string[]).includes(value);

/** Search params of /o/$orgId/clients/$clientId: the open tab (tabs are addressable, 13-ui-ux.md §1). */
export const ClientDetailSearchSchema = z.object({
  tab: z.enum(CLIENT_TABS).optional().catch(undefined),
});
